import { z } from "zod";

// Legado não valida o campo (nenhuma diretiva dc* no template) — exigir
// descrição não-vazia é uma pequena melhoria deliberada, não paridade estrita.
export const tipoArquivoSchema = z.object({
  id: z.number().optional(),
  descricao: z.string().min(1, "Informe a descrição."),
});

export type TipoArquivoFormValues = z.infer<typeof tipoArquivoSchema>;
